import * as Type from './actionsTypes';

const validateInvalidateSubNsmp = (id, validateType, callback) => ({ type: Type.SUBNSMPS_UPDATE_VALIDATE, id, validateType, callback });
const cloneSubNsmp = (id, callback) => ({ type: Type.SUBNSMPS_CLONE, id, callback });
const deleteCloneSubNsmp = (id, callback) => ({ type: Type.SUBNSMPS_DELETE_CLONE, id, callback });

export {
  validateInvalidateSubNsmp,
  cloneSubNsmp,
  deleteCloneSubNsmp,
}
